import Moralis from "moralis";
import { inProduction, nftStakingContract } from "../config/main.config";
import { nftStakingContract as nftPartTwoStakingContract } from "../config/main2.config";

const serverUrl = process.env.REACT_APP_MORALIS_SERVER_URL;
const appID = process.env.REACT_APP_MORALIS_APP_ID;

Moralis.start({
  serverUrl: serverUrl,
  appId: appID,
});

const fetchNFTMetaDataFromApi = (tokenID) => {
  return new Promise(async (resolve, reject) => {
    const nftURI = `https://musclex-nft.herokuapp.com/metaData?tokenId=${tokenID}`;
    const nftData = await fetch(nftURI);
    const nftDataParsed = await nftData.json();
    const response = {
      tokenId: tokenID,
      metaData: nftDataParsed,
    };
    resolve(response);
  });
};

const getNFTsinUserWallet = (userAddress, tokenAddress) => {
  return new Promise(async (resolve, reject) => {
    const nftsInAccountReq = await Moralis.Web3API.account.getNFTsForContract({
      address: userAddress,
      chain: inProduction ? "bsc" : "bsc testnet",
      token_address: tokenAddress,
    });
    const nfts = nftsInAccountReq.result;

    const fetchAllNFTMetaDataPromise = nfts.map((eachNFT) => {
      return fetchNFTMetaDataFromApi(eachNFT.token_id);
    });

    const allNFTMetaData = await Promise.all(fetchAllNFTMetaDataPromise);

    console.log(allNFTMetaData);

    const nftsParsedWithMetadata = nfts.map((eachNFT) => {
      const metaData = allNFTMetaData.filter(
        (nft) => nft.tokenId === eachNFT.token_id
      );
      eachNFT.metadata = metaData[0].metaData;
      return eachNFT;
    });

    console.log(nftsParsedWithMetadata);

    resolve(nftsParsedWithMetadata);
  });
};

const getStakingData = (tokenId, nftPart) => {
  return new Promise(async (resolve, reject) => {
    const contractPromises = await Promise.all([
      fetchNFTMetaDataFromApi(tokenId),
      nftPart === 1
        ? nftStakingContract.calculateRewards(tokenId)
        : nftPartTwoStakingContract.calculateRewards(tokenId),
      nftPart === 1
        ? nftStakingContract.isNFTRewardBNB(tokenId)
        : nftPartTwoStakingContract.isNFTRewardBNB(tokenId),
    ]);

    contractPromises[0].rewards = `${contractPromises[1] / Math.pow(10, 18)} ${
      contractPromises[2] === true ? "BNB" : "MuscleX"
    }`;

    resolve(contractPromises[0]);
  });
};

const getNFTDataStaked = (listOfNFTTokenIds, nftPart) => {
  return new Promise(async (resolve, reject) => {
    const allNftsStakedPromise = listOfNFTTokenIds.map((eachNFTId) => {
      return getStakingData(eachNFTId, nftPart);
    });

    const nftsStaked = await Promise.all(allNftsStakedPromise);
    console.log(nftsStaked);
    resolve(nftsStaked);
  });
};

export { getNFTsinUserWallet, getNFTDataStaked };
